import { createContext, useContext } from "react";

const HistoryContext = createContext(null);

export const useHistoryContext = () => {
  const ctx = useContext(HistoryContext);
  if (!ctx)
    throw new Error("useHistoryContext must be used within HistoryProvider");
  return ctx;
};

export { HistoryContext };
